import { injectGlobal } from 'styled-components';
import './index.css';
import colors from './ui/colors';

injectGlobal`
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons');
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500');

  html, body {
    min-height:100%;
    margin: 0;
  }

  body {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    -webkit-font-smoothing: antialiased;
    background: no-repeat 0 0 url('/img/bg.jpg');
    background-color: ${colors.GREEN_LIGHTEST};
    background-size: cover;
  }

  body.isAuthenticated {
    background: linear-gradient(to bottom, ${colors.GREEN_DARK} 0%, ${colors.GREEN_DARK} 220px, ${colors.GREEN_LIGHTEST} 220px, ${colors.GREEN_LIGHTEST} 100%);
    @media(max-width:520px) {
      background: linear-gradient(to bottom, ${colors.GREEN_DARK} 0%, ${colors.GREEN_DARK} 260px, ${colors.GREEN_LIGHTEST} 260px, ${colors.GREEN_LIGHTEST} 100%);
    }
  }

  #root {
    height: 100vh;
    display: table;
    text-align: center;
    margin: 0 auto;
  }

  #root.isAuthenticated {
    display: block;
    text-align: left;
    height: auto;
  }
  
  // IE Edge table fix
  _:-ms-lang(x), table { table-layout: fixed; }
  
`;



// WEBPACK FOOTER //
// ./src/injectGlobal.js